import BanzaiTheme from './banzai/banzai';
import PulseTheme from './pulse/pulse';
import ReachTheme from './reach/reach';
import ScopeTheme from './scope/scope';
import { Theme } from './theme-base';

export const themeMappings: any = {
  banzai: BanzaiTheme,
  reach: ReachTheme,
  pulse: PulseTheme,
  scope: ScopeTheme,
};

export default function selectTheme(productName: string): Theme {
  return themeMappings[productName] || BanzaiTheme;
}
